export class DateTimeUtils {

  static extractTime(date: string) {
    if (!date) {
        return 0;
    }

    const [day, month, year, hour, minute, seconds] = date.split(/[- :]/);
    const parsedSeconds = seconds !== undefined ? +seconds : 0;
    return (new Date(+year, +month - 1, +day, +hour, +minute, parsedSeconds)).getTime();
  }

  static extractUtcTime(date: string) {
    if (!date) {
        return 0;
    }

    const hasIsoTimezone = date.includes('T') || /Z$/.test(date) || /[+-]\d{2}:\d{2}$/.test(date);
    if (hasIsoTimezone) {
        const parsedIso = Date.parse(date);
        if (!isNaN(parsedIso)) {
            return parsedIso;
        }
    }

    const parts = date.split(/[- :]/);
    if (parts.length < 3) {
        return 0;
    }

    if (parts[0].length === 4) {
        const [year, month, day, hour, minute, seconds] = parts;
        const parsedSeconds = seconds !== undefined ? +seconds : 0;
        return Date.UTC(+year, +month - 1, +day, +(hour || 0), +(minute || 0), parsedSeconds);
    }

    const [day, month, year, hour, minute, seconds] = parts;
    const parsedSeconds = seconds !== undefined ? +seconds : 0;
    return Date.UTC(+year, +month - 1, +day, +(hour || 0), +(minute || 0), parsedSeconds);
  }
}
